import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMG = "/ep3-bg.jpg?v=11";

const lineReveal = {
  hidden: { y: "110%" },
  visible: (i) => ({ y: "0%", transition: { duration: 1, delay: 0.5 + i * 0.18, ease: [0.16, 1, 0.3, 1] } }),
};

const Line = ({ children, i }) => (
  <span className="block overflow-hidden">
    <motion.span custom={i} variants={lineReveal} initial="hidden" animate="visible" className="block">
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "35%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.55, 0.9]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "60%"]);

  return (
    <section ref={ref} id="top" className="relative min-h-screen overflow-hidden flex items-end" data-testid="hero-section">
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img src={HERO_IMG} alt="Chocolate City — candlelit lounge" className="w-full h-full object-cover" style={{ objectPosition: "72% 18%" }} />
      </motion.div>
      <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 z-10 bg-black" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#070202] via-transparent to-[#070202]/60" />

      <motion.div style={{ y: textY }} className="relative z-20 max-w-[1400px] w-full mx-auto px-6 md:px-10 pb-24 md:pb-28">
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4, duration: 1 }}
          className="text-xs md:text-sm uppercase tracking-[0.4em] text-[#D4AF37] mb-6">
          Jay Atk Events &nbsp;presents
        </motion.p>

        <h1 className="font-serif-display text-[13vw] leading-[0.85] md:text-[8rem] md:leading-[0.85] tracking-tight text-[#FDFBF7]">
          <Line i={0}><span className="italic font-light">The</span> <span className="text-gradient-gold">R&B</span></Line>
          <Line i={1}>Day Party</Line>
          <Line i={2}><span className="italic font-light">Series</span></Line>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.4, duration: 1 }}
          className="mt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <p className="max-w-md text-[#A19D94] text-base leading-relaxed">
            Episode Three: Chocolate City — a grown &amp; sexy takeover in shades of brown. Candlelight, R&amp;B, and golden tickets. Saturday, November 28.
          </p>
          <a href="#events" data-testid="hero-cta"
            className="group inline-flex items-center gap-3 self-start text-xs uppercase tracking-[0.25em] border border-[#D4AF37] text-[#D4AF37] px-8 py-4 hover:bg-[#D4AF37] hover:text-black transition-colors duration-300 whitespace-nowrap">
            View Events
            <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};
